import GeneralInfo from './GeneralInfo/GeneralInfo.component';
import MoreInfo from './MoreInfo/MoreInfo.component';
import ContactMe from './ContactMe/ContactMe.component';
import MapProperties from './MapProperties/MapProperties.component';
import Properties from './Properties/Properties.component';

export {
  GeneralInfo,
  MoreInfo,
  ContactMe,
  MapProperties,
  Properties
}